module.exports = __webpack_public_path__ + "static/img_2.f99d1753.png";